import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class GIAAAssuranceService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/GIAAAssurances`);
    }
}